module.exports = __webpack_public_path__ + "img/yellow.1f22fe25.jpg";